import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { GetPolicyRisks } from "../../../../store/user/policyDetails/policyDetailsActions";
import { Box, useMediaQuery } from "@mui/material";
import { RootState } from "../../../../store/store";
import RelatedPolicy from "./RelatedPolicy/RelatedPolicy";
import { IUnderlyingPolicy } from "../../../../models/user/policyDetails/PolicyDetails";
import { driver } from "../../../../constants/Constants";
import Drivers from "../VehiclesAnDrivers/Drivers/Drivers";
import CustomSkeleton from "../../../../common/CustomSkeleton/CustomSkeleton";

const RelatedPolicies = () => {
  const { policyId, carrier, system, lobCode } = useParams();

  const dispatch = useAppDispatch();

  const isMobile = useMediaQuery("(max-width:600px)");

  const { calledReducerType, isLoading } = useAppSelector(
    (state) => state.common
  );

  const { underlyingPolices, policyDrivers } = useAppSelector(
    (state: RootState) => state.policyDetails
  );
  useEffect(() => {
    if (policyId && carrier && system && lobCode) {
      dispatch(GetPolicyRisks({ policyId, carrier, system, lobCode }));
    }
  }, [policyId, carrier, system, lobCode, dispatch]);

  return (
    <Box 
      sx={{ padding: "20px 0px" }}
      id="related_policies_container"
      data-test-id="related_policies_container"
      aria-label="Related policies container"
    >
      {underlyingPolices.map(
        (underlyingPolicy: IUnderlyingPolicy, index: number) => (
          <RelatedPolicy key={index} index={index} policy={underlyingPolicy} />
        )
      )}
      {isLoading && calledReducerType === "policyDetails/GetPolicyRisks" ? (
        <CustomSkeleton
          variant="rounded"
          width="100%"
          height={120}
          animation="wave"
          count={3}
          direction="column"
        />
      ) : policyDrivers.length > 0 ? (
        <Drivers
          drivers={policyDrivers}
          addDriver={false}
          displayMoreOptions={false}
        />
      ) : (
        <></>
      )}
    </Box>
  );
};

export default RelatedPolicies;
